@use '../../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../../styles/Constants.scss' as Constants;

$border: solid 1px Colors.$col-lighterGrey;

.MaterialsList {
	border-left: none;
	display: flex;
	flex-direction: column;
}

.controlsBar {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: Constants.$val-spacing-s;
	gap: Constants.$val-spacing-s;
	border-bottom: $border;

	.input {
		flex: 1;
	}
}

.list {
	flex: 1;
	padding: Constants.$val-spacing-s;
	overflow-y: auto;
	border-left: $border;
}

.countersBar {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	border-top: $border;
	border-left: $border;

	.counters {
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
	}

	.noSearchMatchWarning {
		color: Colors.$col-orange;
	}
}

.MaterialEntryLoading {
	height: 32px;
	margin: 6px 0 4px 0;
	background-color: Colors.$col-greyBackground;
}
